
import { useEffect, useState } from 'react';

export default function FloatingButtons() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight;
      
      // Find the SimpleProcess section by checking all sections
      const sections = document.querySelectorAll('section');
      let simpleProcessSection: Element | null = null;
      
      sections.forEach((section) => {
        const h2 = section.querySelector('h2');
        if (h2 && h2.textContent?.includes('進み方はとてもシンプル')) {
          simpleProcessSection = section;
        }
      });
      
      const simpleProcessTop = simpleProcessSection?.getBoundingClientRect().top || Infinity;
      
      setIsVisible(window.scrollY > heroHeight && simpleProcessTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCTAClick = () => {
    window.open('https://lin.ee/luTEHR8', '_blank');
  };

  return (
    <div
      className={`fixed bottom-8 right-8 z-40 flex flex-col gap-3 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <button
        onClick={handleCTAClick}
        className="bg-[#F2A67E] text-white w-14 h-14 rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.15)] flex items-center justify-center hover:shadow-[0_6px_16px_rgba(0,0,0,0.2)] transition-all duration-250 cursor-pointer"
        aria-label="LINEで相談"
      >
        <i className="ri-line-fill text-3xl"></i>
      </button>

      <button
        onClick={scrollToTop}
        className="w-14 h-14 bg-white rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.15)] flex items-center justify-center hover:shadow-[0_6px_16px_rgba(0,0,0,0.2)] transition-all duration-250 cursor-pointer"
        aria-label="ページトップへ"
      >
        <i className="ri-arrow-up-line text-[#5A4033] text-2xl"></i>
      </button>
    </div>
  );
}